import type {
  ChatsChannelBase,
  ChatsChannelSetting
} from '../../../constants/types';
import { ChatsChannelType } from '../../../constants/types';
import { getChatIcon } from '../../helpers';

export const getEmailSettings = ({ email }: Partial<ChatsChannelBase>) => {
  if (!email) return null;

  const url = `mailto:${email}`;

  return {
    provider: ChatsChannelType.email,
    link: { url, options: { openCurrentPage: true } },
    title: 'Email',
    icon: getChatIcon(ChatsChannelType.email),
    color: 'rgb(21, 136, 255)'
  } as ChatsChannelSetting;
};
